import React, { useState, useEffect } from 'react'
import { Table, Image, OverlayTrigger, FormControl, Button, Dropdown, Collapse } from 'react-bootstrap'
import { FetchDoDataOvertake, FetchDoSQLDump, FetchDoPictureOvertake } from '../../fetcher'
import AlertMessage from '../presentational-components/AlertMessage';


import '../../index.css'
import LoadingSpinner from '../presentational-components/LoadingSpinner';

const MiscelanuousTasks = () => {
    const [showAlertMessage, setShowAlert] = useState(false)
    const [taskName, setTaskName] = useState("")

    const openAlert = () => {
        setShowAlert(true)
    }

    const closeAlert = () => {
        setShowAlert(false)
    }

    const controller = new AbortController()
    const signal = controller.signal

    const overtakeSQLDataFromEasyLogic = (e) => {
        e.preventDefault()
        console.log("MiscelanuousTasks2")
        FetchDoDataOvertake(openAlert, signal, "Overtake1")
    }

    const sqlDump = (e) => {
        e.preventDefault()
        console.log("sqlDump")
        FetchDoSQLDump(openAlert, signal, "Overtake2")
    }

    const pictureOvertake = (e) => {
        e.preventDefault()
        console.log("pictureOvertake")
        FetchDoPictureOvertake(openAlert, signal, "Overtake3")
    }

    return (
        <>
            <div className="inline">
                <Button variant="light" className="text-dark main-menu-navitem main-menu-btn" onClick={(e) => overtakeSQLDataFromEasyLogic(e)} >Datenübernahme aus easyLogic</Button>
                <LoadingSpinner task={"Die Datensicherung wird durchgeführt und die Daten werden von easyLogic übernommen"} area={"Overtake1"} />
            </div>

            <div className="inline">
                <Button variant="light" className="text-dark main-menu-navitem main-menu-btn" onClick={(e) => sqlDump(e)} >Datenspeicherung</Button>
                <LoadingSpinner task={"Die Datensicherung wird durchgeführt"} area={"Overtake2"} />
            </div>

            <div className="inline">
                <Button variant="light" className="text-dark main-menu-navitem main-menu-btn" onClick={(e) => pictureOvertake(e)} >Bilderübernahme</Button>
                <LoadingSpinner task={"Die Bilder werden übernommen"} area={"Overtake3"} />
            </div>
            <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} message={""} />
         </>
        )
}

export default MiscelanuousTasks
